import { styled } from '@mui/material';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { TimePicker as Time } from "@mui/x-date-pickers/TimePicker";
import Typography from "../typography/typography";
import "./time-picker.scss";
import { memo } from "react";

export interface TimePickerProps {
  label: string;
  disabled?: boolean;
  error?: boolean;
  name?: string;
  value?: string | number | Date;
  helperText?: string;
  dataPosition?: number;
  dataName?: string;
  is24hrFormat?: boolean;
  placeholder?: string;
  required?: boolean;
}

const StyledTimePicker = styled(Time)(({ theme: { palette } }) => ({
  "& .MuiOutlinedInput-root": {
    padding: "0",
    color: palette.theme?.secondary[800],
    "& fieldset": {
      borderColor: palette.theme?.secondary[400],
    },
    "&:hover fieldset": {
      borderColor: palette.theme?.secondary[500],
    },
    "&.Mui-focused fieldset": {
      borderWidth: "0.0625rem",
      borderStyle: "solid",
      borderColor: palette.theme?.primary[700],
    },
    "&.Mui-error fieldset": {
      borderColor: palette.theme?.error[600],
    },
    "&.Mui-disabled": {
      background: palette.theme?.secondary[200],
      color: palette.theme?.secondary[800],
    },
    "& .MuiInputBase-input::placeholder": {
      color: palette.theme?.secondary[800],
      opacity: 1,
    },
  },
  "& .MuiFormHelperText-root": {
    marginLeft: 0,
    color: palette.theme?.secondary[800],
    "&.Mui-error": {
      color: palette.theme?.error[600],
    },
  },
  "& .MuiIconButton-root": {
    marginRight: 0,
  },
  "& .MuiPickersCalendarHeader-labelContainer": {
    fontWeight: 600,
  },
}));

const TimePicker = memo((props: TimePickerProps) => {
  const {
    label,
    disabled,
    error,
    helperText,
    dataName,
    dataPosition,
    is24hrFormat = false,
    placeholder,
    required = false,
    ...rest
  } = props;
  return (
    <div>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        {label && (
        <Typography
          type="s4"
          fontWeight={"medium"}
          mb={0.5}
          color={error ? "theme.error.600" : "theme.secondary.800"}
          data-position={dataPosition}
          data-name={dataName}
        >
          {label} {required && <span className="requiredStar">*</span>}
        </Typography>
        )}
        <StyledTimePicker
          {...rest}
          disabled={disabled}
          slotProps={{
            textField: {
              helperText: helperText,
              error: error,
              placeholder: placeholder || "HH:mm A",
              // required: required,
            },
          }}
          format={is24hrFormat ? "HH:MM" : "hh:mm a"}
          className="timePicker"
        />
      </LocalizationProvider>
    </div>
  );
});

export { TimePicker };
export default TimePicker;
